import React from 'react';
import { List, ListItem, ListItemText, Typography, Switch, Divider } from '@mui/material';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { useStore } from '30.quickConnect.Stores';

const UserPreferences = observer(() => {
  const { t } = useTranslation('userSetting');
  const {
    UserSettingsStore: { autoSwitchOU, setAutoSwitchOU },
  } = useStore();

  const handleAutoSwitchOUChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAutoSwitchOU(event.target.checked);
  };

  return (
    <List
      sx={{ width: '100%', bgcolor: 'background.paper', mt: 2 }}
      component="nav"
      subheader={<Typography sx={{ color: '#FF8C00' }}>{t('qcapp_preference_user_preferences')}</Typography>}
    >
      <ListItem>
        <ListItemText
          primaryTypographyProps={{ variant: 'subtitle1', fontWeight: 'bold' }}
          primary={t('qcapp_preference_auto_switch_ou')}
          secondary={
            <Typography sx={{ display: 'inline' }} component="span" variant="body2">
              {t('qcapp_preference_auto_switch_ou_description')}
            </Typography>
          }
        />
        <Switch
          edge="end"
          onChange={handleAutoSwitchOUChange}
          checked={autoSwitchOU}
          inputProps={{
            'aria-labelledby': 'auto-switch-ou-label',
          }}
        />
      </ListItem>
      <Divider variant="fullWidth" />
    </List>
  );
});

export default UserPreferences;
